import store from "../store";
import moment from "moment-timezone";
import { showSnackbarAction } from "../store/actions/Snackbar";
import messages from "../assets/Local/messages";
import * as jwt_decode from "jwt-decode";
import History from "./../routes/History";
import HRCOMLogoNavbar from "../assets/images/0-01.png";
import HRCOMLogoWhite from "../assets/images/ic_logo-footer.svg";
import HRCOMLogoFooter from "../assets/images/0-03.png";
import HRCOMLogoAuth from "../assets/images/0-06.png";
import HRCOMLogoNoWord from "../assets/images/logo-no-word.png";
import LOGO_HOME_HEADER from "../assets/images/imgHero.png";
import Cookies from "js-cookie";
export const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();

export function showSnackbar(message) {
  const lang = store.getState().locale.lang;
  store.dispatch(
    showSnackbarAction(
      typeof message !== "string" ? message['val'] : messages[lang].snackbar[message],
      "success"
    )
  );
}

export function dispatchError(data, message) {
  const errorMsg = data
    ? data.error
      ? data.error.message
      : data.Error.Message
    : message;
  store.dispatch(showSnackbarAction(errorMsg, "error"));
}

export function getDecodedAccessToken(token) {
  try {
    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
}

export function pushToUrlNewParam(page) {
  History.push({
    search: `?page=${page}`,
  });
}

export function getDomain() {
  //new env
  if (window.location.href.includes("stage.hrcom.site")) {
    let host = window.location.host;
    let parts = host.split(".");
    let domain = parts[0].split(`-candidate`)[0];
    const domain_name = process.env.REACT_APP_DOMAIN
      ? process.env.REACT_APP_DOMAIN
      : domain;
    localStorage.setItem("domain", domain_name);
    return domain_name;
  } else {
    let host = window.location.host;
    let parts = host.split(".");
    let domain = parts[0].split(`-${process.env.REACT_APP_URL_CONFIG}`)[0];
    const domain_name = process.env.REACT_APP_DOMAIN
      ? process.env.REACT_APP_DOMAIN
      : domain;
    localStorage.setItem("domain", domain_name);
    return domain_name;
  }
}

export const getYesterdayDate = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
};

export const updateTokenFromUrl = () => {
  const token = getURLParams("token");
  console.log("token",token)
  Cookies.set("token", token, { expires: 1, domain: getEnv() });
};

export function getURLParams(paramName) {
  const queryString = window.location.search;
  console.log("queryString",queryString)
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(paramName);
}

export function parseString(data) {
  if (data) return JSON.parse(data);
  else {
    return null;
  }
}
export const colorsWithPlan = ({
  primary_color,
  secondary_color,
  candidate_home_image,
  plan_features: { has_brand_colors },
  company_subscription_details: { current_plan_end_date },
}) => {
  if (expireAfter3Days(current_plan_end_date)) {
    return {
      ...defaultSetupColors_Logos.colors,
      candidate_home_image: LOGO_HOME_HEADER,
    };
  } else if (has_brand_colors) {
    return {
      primary_color: primary_color ? primary_color : "#86364e",
      secondary_color: secondary_color ? secondary_color : "#ea8685",
      candidate_home_image: candidate_home_image,
    };
  } else if (!has_brand_colors) {
    return {
      ...defaultSetupColors_Logos.colors,
      candidate_home_image: LOGO_HOME_HEADER,
    };
  }
};

export const footerWithPlan = ({
  primary_color,
  secondary_color,
  plan_features: { has_brand_colors },
}) => {
  if (
    has_brand_colors &&
    primary_color === "#86364e" &&
    secondary_color === "#ea8685"
  ) {
    return {
      logo_footer: HRCOMLogoFooter,
    };
  }
  if (
    has_brand_colors &&
    (primary_color !== "#86364e" || secondary_color !== "#ea8685")
  ) {
    return {
      logo_footer: HRCOMLogoWhite,
    };
  }

  if (!has_brand_colors) {
    return {
      logo_footer: HRCOMLogoFooter,
    };
  }
};

export const companyBriefWithPlan = ({
  plan_features: { has_company_brief },
  company_subscription_details: { current_plan_end_date },
}) => {
  if (has_company_brief && !expireAfter3Days(current_plan_end_date)) {
    return {
      hide: false,
    };
  }
  if (!has_company_brief || expireAfter3Days(current_plan_end_date)) {
    return {
      hide: true,
    };
  }
};

export const logoWithPlan = ({
  company_logo_url,
  secondary_color,
  primary_color,
  company_subscription_details,
  plan_features: { has_brand_logo, has_brand_colors },
}) => {
  const expire = company_subscription_details.current_plan_end_date;
  if (expireAfter3Days(expire)) {
    return defaultSetupColors_Logos.logos;
  }
  if (has_brand_logo) {
    return {
      logo_navbar: company_logo_url,
      logo_auth: company_logo_url,
    };
  }
  if (
    has_brand_colors &&
    (primary_color !== "#86364e" || secondary_color !== "#ea8685")
  ) {
    return {
      logo_navbar: HRCOMLogoNoWord,
      logo_auth: HRCOMLogoWhite,
    };
  }
  if (primary_color === "#86364e" && secondary_color === "#ea8685") {
    return defaultSetupColors_Logos.logos;
  }
};

export const expireAfter3Days = (date) => {
  const endDate = new Date(date);
  endDate.setDate(endDate.getDate() + 3);
  let today = new Date();
  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  return date === null ? false : today > endDate;
};

export const defaultSetupColors_Logos = {
  colors: {
    primary_color: "#86364e",
    secondary_color: "#ea8685",
  },
  logos: {
    logo_navbar: HRCOMLogoNavbar,
    logo_auth: HRCOMLogoAuth,
  },
};

export const candidatePortalLogo = (props) => {
  const {
    website_url,
    plan_features: { has_linking_your_website },
  } = props;
  const expire = props.company_subscription_details.current_plan_end_date;
  let disableLink = "";
  let url = jobSeekerUrl();

  if (has_linking_your_website) {
    url = website_url && website_url !== "" ? `${website_url}` : jobSeekerUrl();
  }
  if (expireAfter3Days(expire)) {
    url = jobSeekerUrl();
  }
  return {
    url,
    disableLink,
  };
};
const jobSeekerUrl = () => {
  if (window.location.href.includes("hrcom.ibtikar.sa")) {
    return "https://jobseeker-stage.hrcom.ibtikar.sa";
  } else if (window.location.href.includes("stage.hrcom.site")) {
    return "https://jobseeker.stage.hrcom.site";
  } else if (window.location.href.includes("hrcom.site")) {
    return "https://jobseeker.hrcom.site";
  } else if (window.location.href.includes("hrcom.io")) {
    return `https://jobseeker.hrcom.io`;
  }else if (window.location.href.includes('hrcom.co')) {
    return `https://jobseeker.hrcom.co`;
  }
};

export const authRedirection = (auth, job_post_id = null) => {
  const locale = store.getState().locale;
  if (auth === "login") {
    const result = redirectionOfSpecialPages();
    return `${jobSeekerUrl()}/auth/login?job_post_id=${job_post_id}${
      result
        ? `&${result}&domain=${getDomain()}&locale=${locale?.lang}`
        : `&domain=${getDomain()}&locale=${locale?.lang}`
    }`;
  } else if (auth === "signup") {
    return `${jobSeekerUrl()}/auth/signup?job_post_id=${job_post_id}&domain=${getDomain()}&locale=${
      locale?.lang
    }`;
  } else if (auth === "forget-password") {
    return `${jobSeekerUrl()}/auth/forgetPassword?job_post_id=${job_post_id}&domain=${getDomain()}&locale=${
      locale?.lang
    }`;
  }
};

export const redirectionOfSpecialPages = () => {
  const page = window.location.pathname;
  const search = window.location.search;
  if (
    page === "/moreInformationQuestions" ||
    page === "/offer" ||
    page === "/contractor" ||
    page == "/preoffer" ||
    page == "/profile" ||
    page == "/Profile"
  ) {
    return `page=${page.substring(1)}&${search.substring(1)}`;
  }
};
export const getEnv = () => {
  if (window.location.href.includes("hrcom.ibtikar.sa")) {
    return "hrcom.ibtikar.sa";
  } else if (window.location.href.includes("stage.hrcom.site")) {
    return "stage.hrcom.site";
  } else if (window.location.href.includes("hrcom.site")) {
    return "hrcom.site";
  } else if (window.location.href.includes("hrcom.io")) {
    return `hrcom.io`;
  } else if (window.location.href.includes('hrcom.co')) {
    return `hrcom.co`;
  }else {
    return 'localhost';
  }
};
export const validPhoneNumber = (number, code) => {
  try {
    return !phoneUtil.isValidNumberForRegion(
      phoneUtil.parse(number, code),
      code
    );
  } catch (error) {
    return true;
  }
};

export const getProfileTypeCandidatePortal = () => {
  return store.getState().profile.candidateCompany.profile_type;
};

export const isToday = (pastDate) => {
  const formatedGiven = moment.utc(pastDate).local().format("YYYY-MM-DD");
  const given = moment(formatedGiven, "YYYY-MM-DD");
  const current = moment().startOf("day");
  return moment.duration(given.diff(current)).asDays() == 0 ? true : false;
};
